import { LoginResetPswFormType } from "@delorean/login/schemas/login";

export enum PasswordResetScreen {
  DEFAULT = "ForgetPassword",
  FAILURE_PHY = "FailurePhy",
  APP_NOT_ENROLLED = "AppNotEnrolled",
  FAILURE_BLOCKED = "FailureBlocked",
  GENERIC_FAILURE = "GenericFailure",
  CREDENTIAL_RESETPASSWORD = "CredentialResetPassword",
  RESET_PASSWORD = "ResetPassword",
  RESET_PASSWORD_TEMP = "ResetPasswordTemp",
  SUCCESS = "Success",
  APP_NOTIFICATION = "Notification",
  APP_QRCODE = "QRCode",
}

export type PasswordCriteriaKey =
  | "length"
  | "lowercase"
  | "uppercase"
  | "number"
  | "special"
  | "match";

export type LoginResetPswType = LoginResetPswFormType & { captcha: string };
